import {
  EInvitationStatus,
  IInvitation,
} from '@jupiterone/jupiter-web-toolkit';
import { List, Typography } from '@material-ui/core';
import React from 'react';
import { Check } from 'react-feather';
import useSharedUsersAndAccountStyles from 'navbar/src/jupiterAccountSettings/AccountSettings/useSharedUsersAndAccountStyles';
import InvitationListItem from './InvitationListItem';

interface IProps {
  onInviteAction: (id: string, action: EInvitationStatus) => void;
  invitations: IInvitation[];
}

const InvitationList = ({ invitations, onInviteAction }: IProps) => {
  const classes = useSharedUsersAndAccountStyles();

  const acceptInvitation = (invitation: IInvitation) => {
    onInviteAction(invitation.id, EInvitationStatus.accepted);
  };

  const handleInviteAction = (
    invitation: IInvitation,
    action: EInvitationStatus
  ) => {
    onInviteAction(invitation.id, action);
  };

  return (
    <div className={classes.fadeIn}>
      <div className={classes.headerLayout}>
        <Typography variant="h6" className={classes.groupPanelSubheaderText}>
          Invitations Received
        </Typography>
      </div>
      {invitations.length > 0 ? (
        <List>
          {invitations.map((i: IInvitation, index: number) => (
            <InvitationListItem
              primaryActionIcon={<Check />}
              primaryAction={acceptInvitation}
              onInviteAction={handleInviteAction}
              invitation={i}
              key={index}
            />
          ))}
        </List>
      ) : (
        <Typography variant="body1" className={classes.groupPanelContentText}>
          No pending invitations
        </Typography>
      )}
    </div>
  );
};

export default InvitationList;
